<template lang="pug">
  span
    button.btn.btn-danger(type="button" @click="checkedIds.length ? modalConf = true : modalNoItem = true" title="ログを削除")
      //i.fa.fa-trash
      //|
      //|
      | ログを削除

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- 未選択
    app-modal(v-model="modalNoItem" type="info")
      template(slot="title") 未選択
      h4 名刺を1件以上選択してください。

    //- 確認
    app-modal(v-model="modalConf" type="danger")
      template(slot="title") 確認
      h4 選択したログ情報を削除します。よろしいですか？
      p.text-danger ※名刺情報は削除されません。
      p.text-danger ※この作業は取り消すことができません。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-danger(type="submit" @click="submit") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'

export default {
  name: 'FuncDelCard',
  components: { AppModal },
  props: {
    checkedIds: { type: Array, required: false, default: function () { return [] } }
  },
  data: function () {
    return {
      modalNoItem: false,
      modalConf: false
    }
  },
  methods: {
    submit () {
      this.modalConf = false
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/readerr-bcards/FuncDelLog.vue